<template>
  <v-card>
    <v-toolbar 
      :color="strongColor" 
      flat 
      dark>
      <v-toolbar-title>Current Group Members</v-toolbar-title>
    </v-toolbar>
    <div v-cloak>
    <v-list
      v-if="currentGroupClients">
      <v-list-tile 
        v-for="client in currentGroupClients" 
        :key="client.name">
        <v-list-tile-action>
          <p-check
            v-model="checkedClientsToRemove"
            :name="client.name"
            :value="{name: client.name, id: client.clientsGroupId}"
            checked="false"
          />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title 
            v-text="callFixName(client.name)"/>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    </div>

    <!------ EMBEDDED DIALOG FOR CONFIRMING DELETE -->
     <div 
      v-if="groupId">
    <v-flex>
      <v-dialog 
        v-model="removeClientsDialog" 
        max-width="450">
        <template 
          v-slot:activator="{ on }">

          <v-btn
            :color="strongColor" 
            dark 
            v-on="on">Remove Client(s) From Group</v-btn>
        
        
        </template>
        <v-card>
          <v-card-title 
            my-0 
            class="text-xs-center headline">Remove Client(s) From Group?</v-card-title>
          <v-card-text
            my-0
            class="text-xs-left"
          >Are you sure that you want to remove the selected client(s) from this group?</v-card-text>
          <v-card-actions>
            <v-layout 
              justify-space-between 
              row>
              <v-flex 
                xs6>
                <v-btn 
                :color="strongColor" 
                left 
                dark 
                @click="removeClientsDialog = false">Cancel</v-btn>
              </v-flex>
              <v-flex 
                xs6>
                <v-btn
                  :color="strongColor"
                  right
                  dark
                  @click="removeClientsFromGroup"
                >Remove Client(s) From Group</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
        
    </v-flex>
    </div>
    <!------ END EMBEDDED DIALOG FOR CONFIRMING DELETE -->
  </v-card>
</template>

<script>
import EventBus from "@/main.js"
import ClientsGroupService from "@/services/ClientsGroupService"
import { fixName, STRONG_COLOR } from "@/components/globals/consts"
import {mapState} from 'vuex'

export default {
  /*props: {
    groupId: {
      type: Number,
      required: true
    } 
  },*/
  data() {
    return {
      checkedClientsToRemove: [],
      removeClientsDialog: false,
      strongColor: STRONG_COLOR,
      refresh: 0,
      tempClients: null
    }
  },
	computed: {
		...mapState([
      'currentGroupClients',
      'groupId',
      'searchResults'
		])
  },
//  'tempClients': {
//       immediate: true },


  async created() {

    let t = await this.currentGroupClients.slice()
    t = await t.sort(this.orderByName)
    await this.$store.dispatch('setCurrentGroupClients', t)
    
    this.tempClients=t.slice()
    console.log('created')
  
  },
  async mounted() {
     
    await EventBus.$on("addGroupClients", val => {
      this.removeClientsDialog = false
     //console.log('clientAdded')
     })
    
  },
  methods: {
    async emitMethod(name, value) {
      if (value !== null && value !== undefined) {
        console.log('emitted')
        await EventBus.$emit(name, value)
      }
    },
    callFixName(name) {
      return fixName(name)
    },
    orderByName(a, b) {
      if (a.name.toUpperCase() && b.name.toUpperCase()) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        } else if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        }
        return 0
      }
    },

    async removeClientsFromGroup() {
      let checkedClientsToRemove = this.checkedClientsToRemove.slice()
      let groupId = this.groupId
      let tempArray = this.currentGroupClients.slice()
      let searchResults = this.searchResults.slice()
      for (let client of checkedClientsToRemove) {
        try {
          await ClientsGroupService.remove(client.id)
          console.log('removing')
          tempArray = this.arrayRemove(tempArray,client.id)
          searchResults.push(client)
        } catch (e) {
          console.log(`couldn't delete client ${client}; ${e}`)
        }
      }
      console.log('this.cGC next\n\n\n')
      console.log(this.currentGroupClients)
      console.log('\n\ntemparray next\n\n')
      console.log(tempArray)
      
      await this.$store.dispatch('setCurrentGroupClients', tempArray.slice())
      //this.tempClients = tempArray.slice()
      
      await this.emitMethod('changeGroupClients', 1)
      console.log('this.current group clients next; after emit method')
      console.log(this.currentGroupClients)
      //await this.$store.dispatch('setCurrentGroupClients', tempArray.slice())
      this.checkedClientsToRemove = []
      this.removeClientsDialog = false
      //created()
    },
    arrayRemove(arr, value) {
      return arr.filter(function(element) {
        return element.clientsGroupId != value;
      })
    }
  }
}
</script>

<style scoped>
.controls {
  text-align: left;
  font-family: "Arial";
  font-size: 16px;
  display: inline-block;
}
.title {
  text-align: left;
  font-family: "Arial";
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditClientsInGroup/EditClientsList.vue